import { useEffect, useState } from 'react';
import { getRewardEligibility } from '@/services/index';
import { useWallet, useParams } from '@web3/base-hooks';
import { useBybitWallet } from '@/hooks/wallet';

export const useEligibility = () => {
  const [eligibilityCount, setEligibilityCount] = useState(0);
  const { activityId } = useParams();
  const { walletId, walletType, chainId = 1, isLogin } = useWallet();
  const { walletAddresses } = useBybitWallet();

  const fetchEligibility = async () => {
    const { result, success } = await getRewardEligibility({
      chainId,
      walletId,
      walletType,
      walletAddress: walletAddresses.find((item) => +item.chainId === +chainId)
        ?.walletAddress,
      ...{
        activityId: activityId && +activityId,
      },
    });
    if (success) {
      setEligibilityCount(result.rewardsCount);
    }
  };

  useEffect(() => {
    if (!isLogin) return;
    if (!walletAddresses.length) return;

    fetchEligibility();
  }, [isLogin, walletAddresses.length]);

  return {
    eligibilityCount,
  };
};
